/**
 * Zero pads a number to a given length.
 * @param {number} num
 * @param {number} len
 * @returns {string}
 */
export function zeroPadding(num, len) {
  return (Array(len).join('0') + num).slice(-len)
}

/**
 * Converts milliseconds to HH:mm string.
 * @param {number|null|undefined} time
 * @returns {string}
 */
export function toTime(time) {
  if (time == null) return '00:00'
  const hours = Math.floor(time / (1000 * 60 * 60))
  const minutes = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60))
  return String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0')
}

/**
 * Converts HH:mm string to milliseconds.
 * @param {string|null|undefined} time
 * @returns {number}
 */
export function toMillis(time) {
  if (time == null) return 0
  const [hours, minutes] = time.split(':')
  return (hours * 60 * 60 * 1000) + (minutes * 60 * 1000)
}

export default { zeroPadding, toTime, toMillis }
